import { render, staticRenderFns } from "./SessionDurationChart.vue?vue&type=template&id=5a784746&scoped=true"
import script from "./SessionDurationChart.vue?vue&type=script&lang=js"
export * from "./SessionDurationChart.vue?vue&type=script&lang=js"
import style0 from "./SessionDurationChart.vue?vue&type=style&index=0&id=5a784746&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a784746",
  null
  
)

export default component.exports